export default __webpack_public_path__ + "static/media/sc-undefind.bfe636df.svg";